/**
 * @generated SignedSource<<3b84f49a485d3cc13f4c32f5a8b687c8>>
 * @relayHash 47176e638fd7e368173ae6f124369ecd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bd453aaaa45c5cea6981bfa231b0c0ca6ecc1c8f67b316248809764d9c6791a3

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { RecommendedTabEntryPointRootQuery } from './RecommendedTabEntryPointRootQuery.graphql';

import isForYouNewUsersEnabled_provider from '@jira/platform__graphql-relay-provider/src/JiraForYouLandAllNewUsersRelayProvider';
import isJiraFyRecommendedAssignAgentEnabled_provider from '@jira/platform__graphql-relay-provider/src/JiraFyRecommendedAssignAgentRelayProvider';
import isHexagonSupportEnabled_provider from '@jira/platform__graphql-relay-provider/src/hexagon-support.relayprovider';

const node: PreloadableConcreteRequest<RecommendedTabEntryPointRootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "bd453aaaa45c5cea6981bfa231b0c0ca6ecc1c8f67b316248809764d9c6791a3",
    "metadata": {},
    "name": "RecommendedTabEntryPointRootQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraFyRecommendedAssignAgentRelayProvider": isJiraFyRecommendedAssignAgentEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraForYouLandAllNewUsersRelayProvider": isForYouNewUsersEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider": isHexagonSupportEnabled_provider
    }
  }
};

export default node;
